import { UserNavDropdown } from './view';

export default UserNavDropdown;
